import { c as _c } from "react/compiler-runtime";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import WaveDropContent from "../WaveDropContent";
import useIsTouchDevice from "@/hooks/useIsTouchDevice";
import type { DropContentPresentation } from "../dropContentPresentation";
import type { ImageScale } from "@/helpers/image.helpers";
interface ParticipationDropContentProps {
  readonly drop: ExtendedDrop;
  readonly activePartIndex: number;
  readonly setActivePartIndex: (index: number) => void;
  readonly onLongPress: () => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly setLongPressTriggered: (triggered: boolean) => void;
  readonly isCompetitionDrop?: boolean | undefined;
  readonly mediaImageScale?: ImageScale | undefined;
  readonly fullWidthMedia?: boolean | undefined;
  readonly fullWidthLinkPreviews?: boolean | undefined;
  readonly contentPresentation?: DropContentPresentation | undefined;
  readonly embedPath?: readonly string[] | undefined;
  readonly quotePath?: readonly string[] | undefined;
  readonly embedDepth?: number | undefined;
  readonly maxEmbedDepth?: number | undefined;
}
export default function ParticipationDropContent(t0) {
  const $ = _c(18);
  const {
    drop,
    activePartIndex,
    setActivePartIndex,
    onLongPress,
    onDropContentClick,
    onQuoteClick,
    setLongPressTriggered,
    isCompetitionDrop: t1,
    mediaImageScale,
    fullWidthMedia: t2,
    fullWidthLinkPreviews: t3,
    contentPresentation: t4,
    embedPath,
    quotePath,
    embedDepth,
    maxEmbedDepth
  } = t0;
  const isCompetitionDrop = t1 === undefined ? false : t1;
  const fullWidthMedia = t2 === undefined ? false : t2;
  const fullWidthLinkPreviews = t3 === undefined ? false : t3;
  const contentPresentation = t4 === undefined ? "default" : t4;
  const hasTouch = useIsTouchDevice();
  let t5;
  if ($[0] !== activePartIndex || $[1] !== contentPresentation || $[2] !== drop || $[3] !== embedDepth || $[4] !== embedPath || $[5] !== fullWidthLinkPreviews || $[6] !== fullWidthMedia || $[7] !== hasTouch || $[8] !== isCompetitionDrop || $[9] !== maxEmbedDepth || $[10] !== mediaImageScale || $[11] !== onDropContentClick || $[12] !== onLongPress || $[13] !== onQuoteClick || $[14] !== quotePath || $[15] !== setActivePartIndex || $[16] !== setLongPressTriggered) {
    t5 = <div><WaveDropContent drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onLongPress={onLongPress} onDropContentClick={onDropContentClick} onQuoteClick={onQuoteClick} setLongPressTriggered={setLongPressTriggered} isCompetitionDrop={isCompetitionDrop} mediaImageScale={mediaImageScale} mediaContainerHeightClassName="tw-h-96" fullWidthMedia={fullWidthMedia} fullWidthLinkPreviews={fullWidthLinkPreviews} hasTouch={hasTouch} contentPresentation={contentPresentation} embedPath={embedPath} quotePath={quotePath} embedDepth={embedDepth} maxEmbedDepth={maxEmbedDepth} /></div>;
    $[0] = activePartIndex;
    $[1] = contentPresentation;
    $[2] = drop;
    $[3] = embedDepth;
    $[4] = embedPath;
    $[5] = fullWidthLinkPreviews;
    $[6] = fullWidthMedia;
    $[7] = hasTouch;
    $[8] = isCompetitionDrop;
    $[9] = maxEmbedDepth;
    $[10] = mediaImageScale;
    $[11] = onDropContentClick;
    $[12] = onLongPress;
    $[13] = onQuoteClick;
    $[14] = quotePath;
    $[15] = setActivePartIndex;
    $[16] = setLongPressTriggered;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}